import React from "react";
import { Button } from "semantic-ui-react";
import Shutdown1_MAIN from "./Shutdown1_MAIN";
import Shutdown2_MAIN from "./Shutdown2_MAIN";
import Shutdown3_MAIN from "./Shutdown3_MAIN";
import Shutdown4_MAIN from "./Shutdown4_MAIN";

const Shutdown_MAIN = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <Shutdown1_MAIN />;
      case "2":
        return <Shutdown2_MAIN />;
      case "3":
        return <Shutdown3_MAIN />;
      // case '4':
      //     return <Shutdown4_MAIN/>;
      // case '5':
      //     return <Shutdown5/>;
      default:
        return <Shutdown1_MAIN />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="SHUTDOWNS PAGE1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="SHUTDOWNS PAGE2"
        />
        <Button
          size="medium"
          id="3"
          active={toggleButton === "3"}
          onClick={handleClick}
          content="SHUTDOWNS PAGE3"
        />
        {/* <Button
                    size='medium'
                    id='4'
                    active={toggleButton==='4'}
                    onClick={handleClick}
                    content='SHUTDOWNS PAGE4'
                /> */}
        {/* <Button
                    size='medium'
                    id='5'
                    active={toggleButton==='5'}
                    onClick={handleClick}
                    content='SHUTDOWNS PAGE5'
                /> */}
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default Shutdown_MAIN;
